import { nextTick } from "@vue/composition-api";

export const waitTicks = async (times: number): Promise<void> => {
  let counter = 0;
  while (counter++ < times) await nextTick();
};
